export default "__VITE_PUBLIC_ASSET__645c12b7__"